import { render, staticRenderFns } from "./PleitoDespesasSebrae.vue?vue&type=template&id=33a41ecf"
import script from "./PleitoDespesasSebrae.vue?vue&type=script&lang=js"
export * from "./PleitoDespesasSebrae.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports